// PRE-ORDER BUTTON LOGIC
document.addEventListener('DOMContentLoaded', function() {
  var addToCartButton = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
  var preorderSection = document.getElementById('line-item-preorder-section');
  var preorderCheckbox = preorderSection ? preorderSection.querySelector('input[type="checkbox"]') : null;
  var productStatus = window.productStatus;
  var variantMetafields = window.variantMetafields;

  if (!addToCartButton || !preorderSection || !preorderCheckbox) return;

  function updateButtonAndLineItem(variant) {
    var variantId = variant.id;
    var isPreOrder = variantMetafields[variantId] === "true";

    if (productStatus === "PRE-ORDER" || isPreOrder) {
      addToCartButton.textContent = 'Pre-order';
      preorderSection.style.display = 'block';
      preorderCheckbox.required = true;
      
      // Update countdown when variant changes
      if (window.updateShippingCountdown) {
        window.updateShippingCountdown(variantId);
      }
      
    } else {
      preorderSection.style.display = 'none';
      preorderCheckbox.required = false;
    }
  }

  document.addEventListener('variant:change', function(event) {
    var variant = event.detail.variant;
    if (variant) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
            if (!addToCartButton.disabled) {
              observer.disconnect();
              updateButtonAndLineItem(variant);
            }
          }
        });
      });

      observer.observe(addToCartButton, { attributes: true });
    }
  });

  var initialVariantId = document.querySelector('[name="id"]').value;
  updateButtonAndLineItem({ id: initialVariantId });

  addToCartButton.addEventListener('click', function(event) {
    if (preorderSection.style.display === 'block' && !preorderCheckbox.checked) {
      event.preventDefault();
      
      // Scroll to checkbox
      preorderSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Add error styling
      preorderSection.classList.add('preorder-section-error');
      
      // Remove after animation
      setTimeout(function() {
        preorderSection.classList.remove('preorder-section-error');
      }, 2000);
    }
  });
});